import {
  axiosInstanceContratos,
  axiosInstanceMain,
} from "../../../utils/axiosGlobalUtils";
import { hash } from "../../../utils/hashFunction";
import { ITenant } from "../../AbmLocalPage/types";

export const getContratosList = async (idLocal: any): Promise<any[]> => {
  const clave = await hash(idLocal.toString() + "lugares2017");
  const contratosData = (
    await axiosInstanceContratos.get(
      `/contratos/local/${idLocal}?clave=` + clave
    )
  ).data;

  return contratosData;
};

export const getContactoLocal = async (
  idLocal: any,
  tenant: ITenant
): Promise<any[]> => {
  const contactoLocal = (
    await axiosInstanceMain.post(`/${tenant.path}/locales/${idLocal}?vendedor`)
  ).data.config;
  const whppContratos = (await contactoLocal).find(
    (item: any) => item.name === "whatsappContratos"
  ).value;

  return whppContratos;
};
